import { Company } from "models/company";
import { UserContact } from "models/user-contact";
import React from "react";
import { InitContextProps, useAuthContext } from "services/context/authentication.context";
import RoleSelectCard from "./RoleSelectCard";

interface RoleSelectListProps {
    contacts: UserContact[];
    companies: Company[];
    hasActiveCustomer: boolean;
    onCustomerChange: (customerId: number, isPerson: boolean) => void;
    onRegister: (isCompany: boolean, company?: Company) => void;
}

export default function RoleSelectList(props: RoleSelectListProps) {

    const { state }: InitContextProps = useAuthContext();


    const isOwnCompany = (registryNumber: string): boolean => {
        return props.companies.some(c => c.registryNumber === registryNumber);
    }

    const isSelf = (personalCode: string) => state.user.personalIdentificationCode === personalCode;

    const persons = props.contacts.filter(c => c.isPerson || isSelf(c.registryNumber));
    const contacts = props.contacts.filter(c => !c.isPerson && !isSelf(c.registryNumber));
    const unregisteredCompanies = props.companies.filter(c => !c.customerId || !contacts.some(co => co.registryNumber === c.registryNumber));
    const isPersonUnregistered = state.user && !persons.some(c => c.registryNumber === state.user.personalIdentificationCode);

    return (
        <div className="d-flex flex-column">
        { isPersonUnregistered ? 
            <RoleSelectCard
                selectable={false}
                selected={false}
                title={state.user.name}
                isCompany={false}
                isMandate={false}
                canRegister={true}
                onRegister={() => props.onRegister(false)}
            />
         : null}
        { persons.map(c => (
            <RoleSelectCard
                key={c.registryNumber}
                selectable={true}
                onSelect={() => props.onCustomerChange(c.customerId, c.isPerson)}
                selected={props.hasActiveCustomer && state.customerId === c.customerId}
                title={c.customerName}
                isCompany={false}
                isMandate={!isSelf(c.registryNumber)}
                canRegister={false}
            />
        ))}
        { (!!contacts.length || !!unregisteredCompanies.length) && <div className="u-hr"></div>}
        { contacts.map(c => (
            <RoleSelectCard
                key={c.registryNumber}
                selectable={true}
                onSelect={() => props.onCustomerChange(c.customerId, c.isPerson)}
                selected={props.hasActiveCustomer && state.customerId === c.customerId}
                title={c.customerName}
                isCompany={true}
                isMandate={!isOwnCompany(c.registryNumber)}
                canRegister={false}
            />
        ))}
        { unregisteredCompanies.map(c => (
            <RoleSelectCard
                key={c.registryNumber}
                selectable={false}
                selected={false}
                title={c.name}
                isCompany={true}
                isMandate={false}
                canRegister={true}
                onRegister={() => props.onRegister(true, c)}
            />
        ))}
    </div>
    )
}